// 共通のslick設定
export const commonSlickOptions = {
  variableWidth: true,
  slidesToScroll: 3,
  slidesToShow: 4,
  infinite: false,
  arrows: true,
  responsive: [{
    breakpoint: 1286,
    settings: {
      slidesToShow: 3,
    }
  }],
};

// 特集・ピックアップ 用のslick設定
export const pickupSlickOptions = {
  infinite: false,
  slidesToScroll: 3,
  slidesToShow: 8,
  responsive: [{
    breakpoint: 1286,
    settings: {
      slidesToShow: 7,
    }
  }],
};

// 最近見たプログラム 動画のslick設定
export const programMovieSlickOptions = {
  // ul.program__movie-list の直接子は li。Slick はこの要素に slick-slide を付与する（div で挟まない）
  slide: 'li',
  variableWidth: true,
  rows: 0,
  slidesToShow: 2,
  slidesToScroll: 2,
  infinite: false,
  arrows: true,
  dots: false,
  edgeFriction: 0,
  prevArrow: '.program__arrow--prev',
  nextArrow: '.program__arrow--next',
  // SP（668px 以下）はネイティブ横スクロールに切り替え
  responsive: [
    {
      breakpoint: 668,
      settings: 'unslick'
    }
  ],
};
